import { DST_STATES } from '@cont/SeeAll/TestSeriesListing/DailyScholarshipTest/utils';
import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import { getImage } from '@utils/imageHelper';
import Typography from 'aquilla/core/atoms/Typography';
import Button from 'aquilla/core/molecules/Button';
import React, { useCallback, useEffect, useState } from 'react';
import TimeRemaining from 'aquilla/icons/misc/TimeRemaining';
import { getShortFormTimeFormat } from '@utils/dates';
import { useSWRConfig } from 'swr';
import { getDSTEndpoint } from '@cont/SeeAll/TestSeriesListing/DailyScholarshipTest/apiHelper';
import { useRouter } from 'next/router';
import usePreciseTimer from '@hooks/usePreciseTimer';

const BannerContainer = styled.div`
  background: rgba(253, 242, 205, 0.4);
  background-repeat: no-repeat;
  background-position: right top;

  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const BannerContentWrapper = styled.div`
  width: var(--layout-width);
  margin: 0 auto;

  ${mediaQuery.uptoTablet} {
    width: var(--layout-mweb-width);
  }
`;

const BannerContent = styled.div`
  padding: 51.5px 0;
  background-image: url('${getImage('/dst/ongoingTest.svg')}');
  background-repeat: no-repeat;
  background-position: right;
`;

const ButtonWrapper = styled.div``;

const StyledButton = styled(Button)`
  width: auto;
`;

const SubHeader = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  margin: ${Spacings.SPACING_2B} 0 ${Spacings.SPACING_5B};
`;

const getButtonLabel = (dstState) => {
  switch (dstState) {
    case DST_STATES.RESUME:
      return 'Resume';
    case DST_STATES.ATTEMPTED:
      return 'View attempt summary';
    default:
      break;
  }
};

const Attempted = ({ block, onClick, clickHandlers }) => {
  const { data, extraBlockInfo } = block;
  const { header, subHeader } = extraBlockInfo;
  const { finishTime = 0, state: dstState, quizUid, sessionUid } = data[0];
  const {
    query: { goalUID }
  } = useRouter();

  const [timeRemaining, setTime] = useState(
    Math.round((new Date(finishTime).getTime() - new Date().getTime()) / 1000)
  );

  const handler = useCallback(() => {
    setTime((time) => time - 1);
  }, []);

  const { mutate } = useSWRConfig();

  useEffect(() => {
    if (timeRemaining === 0) mutate(getDSTEndpoint(goalUID));
  }, [timeRemaining, mutate, goalUID]);

  usePreciseTimer(handler, 1000, true);

  const handleClick = useCallback(() => {
    if (onClick) onClick();
    switch (dstState) {
      case DST_STATES.RESUME:
        return clickHandlers.takeTest();

      case DST_STATES.ATTEMPTED:
        return clickHandlers.viewAttempts(quizUid, sessionUid);

      default:
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dstState, quizUid, sessionUid]);

  return (
    <BannerContainer>
      <BannerContentWrapper>
        <BannerContent>
          <Typography variant="h3">{header}</Typography>
          {dstState === DST_STATES.RESUME && (
            <SubHeader>
              <TimeRemaining
                height={20}
                width={20}
                color="var(--color-i-red)"
              />
              <Typography color="var(--color-i-red)" variant="h5">
                {`Expires in ${getShortFormTimeFormat(timeRemaining)}`}
              </Typography>
            </SubHeader>
          )}
          {dstState === DST_STATES.ATTEMPTED && (
            <SubHeader>
              <Typography color="var(--color-text-secondary)" variant="p1">
                {subHeader}
              </Typography>
            </SubHeader>
          )}
          <ButtonWrapper>
            <StyledButton
              label={getButtonLabel(dstState)}
              variant={
                dstState === DST_STATES.ATTEMPTED ? 'secondary' : 'primary'
              }
              size="large"
              onClick={handleClick}
            />
          </ButtonWrapper>
        </BannerContent>
      </BannerContentWrapper>
    </BannerContainer>
  );
};

export default Attempted;
